import React from "react";
import { BackgroundImage, HeaderComponent } from "../../FifthComponents";

const CoreValues = (props) => {
    const { selectedLanguage } = props;
    return (
        <div>
            <BackgroundImage screenName={selectedLanguage?.txt_our_core_values} classForBg='fifth-des-core-values-bg' {...props}/>
            <HeaderComponent title={selectedLanguage?.txt_our_core_values} lineClass='bg-gray' titleClass='color-blue' />
            <div className="who-we-are-main-div">
                <h3>
                    {selectedLanguage?.txt_new_perspective_to_local_healthcare}
                </h3>
                <p>
                    {selectedLanguage?.txt_amsterdam_clinics_is_here_to_put}
                </p>
                <h3>
                    {selectedLanguage?.txt_wholistic_approach}
                </h3>
                <p>
                    {selectedLanguage?.txt_holistic_approach}
                </p>
                <h3>
                    {selectedLanguage?.txt_dutch_care_quality_standard}
                </h3>
                <p>
                    {selectedLanguage?.txt_amsterdam_clinics_dutch_healthcare_system}
                </p>
                <h3>
                    {selectedLanguage?.txt_patient_focused_culture}
                </h3>
                <p>
                    {selectedLanguage?.txt_quality_healthcare}
                </p>
                <h3>
                    {selectedLanguage?.txt_long_term_relationships}
                </h3>
                <p>
                    {selectedLanguage?.txt_long_term_relationships_we_are_a_true_healthcare}
                </p>
            </div>
        </div>
    )
}
export default CoreValues